<div class="or-head-xs or-color-secondary-2 or-mb-8-px">Dodaj osoby do gierki</div>
<div
  [shareGame]="game"
  class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
  <or-icon name="copy-link" size="s" boxed class="or-mr-8-px" />
  <div>
    <div class="or-text-md">Skopiuj link do gierki</div>
  </div>
</div>

<div
  (click)="addPlayer()"
  class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
  <or-icon name="plus" size="s" boxed class="or-mr-8-px" />
  <div class="or-text-md">Dodaj gracza ręcznie</div>
</div>

<div
  (click)="goToInvitations()"
  class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
  <or-icon name="notifications-2" size="s" boxed class="or-mr-8-px" />
  <div class="or-text-md">Zaproś dawnych graczy</div>
</div>
